//
//
//
//
//

export default {
  name: 'c_divider'
};